import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePortalDestination } from './PortalDestinationContext';
import { PRIMARY_NAV } from './portalNavigation';
import { usePortalUnread } from './PortalUnreadContext';
import { PortalUnreadBadge, unreadChatLabel } from './PortalUnreadBadge';

/** Fixed bottom tab bar — mobile only (see portalMobile.css). Exactly the five primary destinations. */
export const PortalMobileNavigation = () => {
  const { href, parsed } = usePortalDestination();
  const { count } = usePortalUnread();
  const [keyboard, setKeyboard] = useState(false);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    let fullHeight = viewport.height;
    const update = () => {
      const editing = document.activeElement?.matches('input, textarea, [contenteditable="true"]');
      if (!editing) fullHeight = Math.max(viewport.height, window.innerHeight);
      setKeyboard(Boolean(editing && viewport.scale === 1 && fullHeight - viewport.height > 150));
    };
    viewport.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      viewport.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);
  return (
    <nav className={`portal-bottom-nav${keyboard ? ' portal-keyboard-open' : ''}`} aria-label="Mobile patient services" data-testid="portal-mobile-navigation">
      {PRIMARY_NAV.map(({ page, icon: Icon, label, id, matches }) => {
        const isActive = (matches || [page]).includes(parsed.page);
        return <Link key={id} to={href(page)}
          aria-label={id === 'chat' ? unreadChatLabel(count) : undefined}
          className="portal-bottom-tab" aria-current={isActive ? 'page' : undefined}
          data-testid={`portal-mobile-nav-${id}`}>
          <span className="portal-tab-icon"><Icon size={21} strokeWidth={isActive ? 2.4 : 1.8} aria-hidden="true" />
            {id === 'chat' && <PortalUnreadBadge count={count} floating testId="portal-mobile-chat-unread-count" />}
          </span>
          <span>{label}</span>
        </Link>;
      })}
    </nav>
  );
};
